import { createAsyncThunk } from "@reduxjs/toolkit";
import { getActiveOrders } from "@shared/services/orders/orders.service";

export const getActiveOrdersAsyncThunk = createAsyncThunk("getActiveOrdersAsyncThunk", async () => {
  const orders = await getActiveOrders();
  return orders;
});
